import { useState } from 'react';

import LuckyWheel from './LuckyWheel_v2';
import { useLuckyWheelPrizesQuery } from '@hooks/luckywheel/luckyWheel.gql.generated';

export interface NormalizedPrize {
  id: string;
  name: string;
  quantity: number;
}

interface LuckyWheelContainerProps {
  campaignId: string;
  showBuyMore: boolean;
  noMoreSpin: boolean;
  setVisible?: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function LuckyWheelContainer(props: LuckyWheelContainerProps) {
  const { campaignId, showBuyMore, noMoreSpin, setVisible } = props;
  const [key, setKey] = useState(0);

  const { data } = useLuckyWheelPrizesQuery({
    variables: {
      campaignId,
    },
  });

  const prizes = data?.luckyWheelPrizes;

  if (!prizes) return null;

  return (
    <LuckyWheel
      key={key}
      reset={() => setKey(prev => prev + 1)}
      campaignId={campaignId}
      prizes={prizes}
      showBuyMore={showBuyMore}
      noMoreSpin={noMoreSpin}
      setVisible={setVisible}
    />
  );
}
